(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Invalid",
            {
                url: "/Invalid?param={parameter}",
                component: "invalid",
                PageTitle: "Invalid Link",
                resolve: {
                    password: ["$stateParams", function ($stateParams) {
                        console.log($stateParams);
                        if ($stateParams.param === "password")
                            return true;
                        return false;
                    }]
                }
            });
    }]);

    app.component("invalid",
        {
            templateUrl: "App/Register/Invalid/template.html",
            controller: invalidController,
            bindings: {
                password: "<"
            }

        });

    invalidController.$inject = [];
    function invalidController() {
        var $ctrl = this;
        ng.extend($ctrl,
            {

            });
    };

})(window.app, window.angular);